import Page from "../../../components/Page";
import Content from "../../../components/Content";
import WarningMessage from "../../../components/WarningMessage";
import { determineManualOrder } from "../../../utils/ManualOrderUtils";
const EventDataChecks = event => {
  const isManualOrder = determineManualOrder();
  if (event.loading || !event.data) {
    return <Page />;
  }
  if (event.data.suspendSales && !isManualOrder) {
    return (
      <Page background={true} border={true}>
        <Content>
          <WarningMessage
            title="Ticket Sales Unavailable"
            message="Ticket sales have ended"
          />
        </Content>
      </Page>
    );
  }
  if (!event.data.validDates.length && !isManualOrder) {
    return (
      <Page background={true} border={true}>
        <Content>
          <WarningMessage title="Ticket Sales Unavailable" />
        </Content>
      </Page>
    );
  }
  return false;
};

export default EventDataChecks;



// WEBPACK FOOTER //
// ./routes/tickets/components/EventDataChecks.js